import ServiceRestrictSetting from 'domains/models/service_restrict_setting';
import { z } from 'zod';

export type ServiceRestrictSettingCreateBody = z.infer<
  typeof schemaServiceRestrictSettingCreateBody
>;
export const schemaServiceRestrictSettingCreateBody = z.object({
  isEnableTotalMaxUsesCount: z.boolean(),
  isEnableUserMaxUsesCount: z.boolean(),
  totalMaxUsesCount: z.number(),
  userMaxUsesCount: z.number(),
  isRestrictCount: z.boolean(),
  restrictCountDay: z.number().nullable(),
  restrictCountWeek: z.number().nullable(),
  restrictCountMonth: z.number().nullable(),
});

export type ServiceRestrictSettingUpdateBody = z.infer<
  typeof schemaServiceRestrictSettingUpdateBody
>;
export const schemaServiceRestrictSettingUpdateBody = z.object({
  isEnableTotalMaxUsesCount: z.boolean(),
  isEnableUserMaxUsesCount: z.boolean(),
  totalMaxUsesCount: z.number(),
  userMaxUsesCount: z.number(),
  isRestrictCount: z.boolean(),
  restrictCountDay: z.number().nullable(),
  restrictCountWeek: z.number().nullable(),
  restrictCountMonth: z.number().nullable(),
});

export type ServiceRestrictSettingCreateResult = z.infer<
  typeof schemaServiceRestrictSettingCreateResult
>;
export const schemaServiceRestrictSettingCreateResult = z.object({
  id: z.number(),
});

export type ServiceRestrictSettingUpdateResult = z.infer<
  typeof schemaServiceRestrictSettingUpdateResult
>;
export const schemaServiceRestrictSettingUpdateResult = z.object({
  id: z.number(),
});

export type ServiceRestrictSettingItem = z.infer<
  typeof schemaServiceRestrictSettingItem
>;
export const schemaServiceRestrictSettingItem = z.object({
  serviceId: z.number(),
  teamId: z.number(),
  isEnableTotalMaxUsesCount: z.boolean(),
  totalMaxUsesCount: z.number(),
  userMaxUsesCount: z.number(),
  isEnableUserMaxUsesCount: z.boolean(),
  isRestrictCount: z.boolean(),
});

export const toItem = (
  setting: ServiceRestrictSetting,
): ServiceRestrictSettingItem => {
  return {
    serviceId: setting.serviceId!,
    teamId: setting.teamId,
    isEnableTotalMaxUsesCount: setting.isEnableTotalMaxUsesCount,
    totalMaxUsesCount: setting.totalMaxUsesCount,
    isEnableUserMaxUsesCount: setting.isEnableUserMaxUsesCount,
    userMaxUsesCount: setting.userMaxUsesCount,
    isRestrictCount: setting.isRestrictCount,
  };
};

export type ServiceRestrictSettingListItem = z.infer<
  typeof schemaServiceRestrictSettingListItem
>;
export const schemaServiceRestrictSettingListItem = z.object({
  serviceId: z.number(),
  teamId: z.number(),
  totalMaxUsesCount: z.number().nullable(),
  userMaxUsesCount: z.number().nullable(),
  isRestrictCount: z.boolean(),
});

export const toListItem = (
  setting: ServiceRestrictSetting,
): ServiceRestrictSettingListItem => {
  return {
    serviceId: setting.serviceId!,
    teamId: setting.teamId,
    totalMaxUsesCount: setting.totalMaxUsesCount,
    userMaxUsesCount: setting.userMaxUsesCount,
    isRestrictCount: setting.isRestrictCount,
  };
};
